import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const LanguageSwitcher = ({ className = "" }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className={`inline-flex items-center bg-gray-100 rounded-lg p-1 border border-gray-200 ${className}`}>
      <button
        type="button"
        onClick={() => setLanguage('de')}
        className={`px-3 py-1.5 rounded-md text-sm font-bold transition-all duration-200 min-w-[3rem] ${
          language === 'de'
            ? 'bg-white text-sunrise-red shadow-sm'
            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
        }`}
        title="Deutsch"
        aria-label="Switch to German"
      >
        DE
      </button>
      <button
        type="button"
        onClick={() => setLanguage('en')}
        className={`px-3 py-1.5 rounded-md text-sm font-bold transition-all duration-200 min-w-[3rem] ${
          language === 'en'
            ? 'bg-white text-sunrise-red shadow-sm'
            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
        }`}
        title="English"
        aria-label="Switch to English"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
